var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-combobox',{attrs:{"items":_vm.countries,"item-text":"name","label":_vm.label,"color":"#000080","error-messages":_vm.errorMessages,"solo":""},model:{value:(_vm.country),callback:function ($$v) {_vm.country=$$v},expression:"country"}})
}
var staticRenderFns = []

export { render, staticRenderFns }